import { render, staticRenderFns } from "./TiposCompromisso.vue?vue&type=template&id=20171f4e"
import script from "./TiposCompromisso.vue?vue&type=script&lang=js"
export * from "./TiposCompromisso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports